// PRODUCT COLLAPSIBLE TABS

var productDescription = document.querySelector(".product-description");

// Select all product-description h5s
var h5s = productDescription.querySelectorAll("h5");

// Loop through each h5
for (var i = 0; i < h5s.length; i++) {
  // Set variable for next element
  var next = h5s[i].nextSibling;
  // Create empty array to store all elements to move
  var all = [];
  // Loop through next elements until next h5 is reached
  while (next && next.tagName !== "H5") {
    if(next.nodeType == 3){
      console.log("non: "+next);
    }
    // Add elements to array
    all.push(next);
    // Set next element
    next = next.nextSibling;
  }
  // Create details element
  var details = document.createElement("details");
  // Set class name
  details.classList.add("collapsible-tab");
  // if product description has data-firstopen attribute, and we're on the first tab set open attribute
  if (productDescription.hasAttribute("data-firstopen") && i == 0) {
    details.setAttribute("open", "");
  }
  // Create summary element
  var summary = document.createElement("summary");
  // Set class name
  summary.classList.add("collapsible-tab__heading");
  // Create div element
  var div = document.createElement("div");
  // Set class name
  div.classList.add("collapsible-tab__text");
  // Insert details element before h5
  h5s[i].parentNode.insertBefore(details, h5s[i]);
  // Append summary and div to details
  details.appendChild(summary);
  details.appendChild(div);
  // append text to summary and remove h5
  summary.appendChild(h5s[i].firstChild);
  // append svg arrow to summary
  var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.setAttribute("aria-hidden", "true");
  svg.setAttribute("focusable", "false");
  svg.setAttribute("role", "presentation");
  svg.setAttribute("width", "8");
  svg.setAttribute("height", "6");
  svg.setAttribute("viewBox", "0 0 8 6");
  svg.setAttribute("fill", "none");
  svg.classList.add("icon-chevron-down");
  var path1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
  path1.classList.add("icon-chevron-down-left");
  path1.setAttribute("d", "M4 4.5L7 1.5");
  path1.setAttribute("stroke", "currentColor");
  path1.setAttribute("stroke-width", "1.25");
  path1.setAttribute("stroke-linecap", "square");
  var path2 = document.createElementNS("http://www.w3.org/2000/svg", "path");
  path2.classList.add("icon-chevron-down-right");
  path2.setAttribute("d", "M4 4.5L1 1.5");
  path2.setAttribute("stroke", "currentColor");
  path2.setAttribute("stroke-width", "1.25");
  path2.setAttribute("stroke-linecap", "square");
  svg.appendChild(path1);
  svg.appendChild(path2);
  summary.appendChild(svg);
  // Remove h5
  h5s[i].parentNode.removeChild(h5s[i]);
  // Loop through all remaining content elements
  for (var j = 0; j < all.length; j++) {
    // Append elements to div
    div.appendChild(all[j]);
  }
}

// Make product-description animate fade in
productDescription.classList.add("fading");
// remove .product-description class to prevent conflict with dumb tab app
productDescription.classList.remove("product-description");

// If stock_shipping is present, add content from .small-promo-content
var stockShipping = document.querySelector(
  ".stock_shipping .small-promo-shipping"
);
if (stockShipping) {
  var smallPromoContent = document.querySelector(".small-promo-content");
  stockShipping.innerHTML = smallPromoContent.textContent;
}
